export default class Helper {
    constructor(){

    }

    static isLoggedIn(){
        return sessionStorage.getItem('token') !== null && sessionStorage.getItem('token') !== undefined;
    }
}